// import api from '../api/client';
// import React, { useState, useEffect } from 'react';
// import {
//     Form,
//     Input,
//     InputNumber,
//     DatePicker,
//     Button,
//     Card,
//     message,
//     Select,
//     Typography,
//     Space,
//     Table,
//     Popconfirm,
//     Spin,
//     Alert,
//     Checkbox,
//     Divider,
//     Row,
//     Col,
//     Tag
// } from 'antd';
// import { PlusOutlined, DeleteOutlined, WarningOutlined, ArrowLeftOutlined, InboxOutlined, TeamOutlined } from '@ant-design/icons';
// import { useHistory } from 'react-router-dom';
// import moment from 'moment';
// import config from '../config';
// import { useSelector } from 'react-redux';
// import { Link } from 'react-router-dom';

// const { Title, Text } = Typography;
// const { Option } = Select;

// const ConsumptionPage = () => {
//     const history = useHistory();
//     const account = useSelector((state) => state.account.user);
//     const [form] = Form.useForm();
//     const [loading, setLoading] = useState(false);
//     const [items, setItems] = useState([]);
//     const [consumptionsList, setConsumptionsList] = useState([]);
//     const [categories] = useState(['poultry', 'pig', 'goat', 'sheep', 'weaner', 'general']);
//     const [animalsMap, setAnimalsMap] = useState({});
//     const [silosMap, setSilosMap] = useState({});
//     const [loadingAnimals, setLoadingAnimals] = useState({});
//     const [loadingSilos, setLoadingSilos] = useState({});
//     const [validationErrors, setValidationErrors] = useState({});

//     const fetchItems = async () => {
//         try {
//             const res = await api.get('/items-cost');
//             setItems(res.data);
//         } catch (error) {
//             console.error('Error fetching items:', error);
//             message.error('Failed to load items');
//         }
//     };

//     // Fetch animals for a given category
//     const fetchAnimals = async (category, rowIndex) => {
//         if (!category) return;
//         setLoadingAnimals((prev) => ({ ...prev, [rowIndex]: true }));
//         try {
//             const res = await api.get('/animals', { params: { type: category, status: 'alive' } });
//             setAnimalsMap((prev) => ({ ...prev, [rowIndex]: res.data }));
//         } catch (error) {
//             console.error('Error fetching animals:', error.response?.data?.error || error.message);
//         } finally {
//             setLoadingAnimals((prev) => ({ ...prev, [rowIndex]: false }));
//         }
//     };

//     // Fetch silos for a given category
//     const fetchSilos = async (category, rowIndex) => {
//         if (!category) return;
//         setLoadingSilos((prev) => ({ ...prev, [rowIndex]: true }));
//         try {
//             const res = await api.get(`/silos/by-type/${category}`);
//             setSilosMap((prev) => ({ ...prev, [rowIndex]: res.data || [] }));
//         } catch (error) {
//             console.error('Error fetching silos:', error);
//             setSilosMap((prev) => ({ ...prev, [rowIndex]: [] }));
//         } finally {
//             setLoadingSilos((prev) => ({ ...prev, [rowIndex]: false }));
//         }
//     };

//     useEffect(() => {
//         fetchItems();
//     }, []);

//     // Add a new empty row
//     const addRow = () => {
//         const newRow = {
//             key: Date.now(),
//             category: null,
//             consumption_type: 'animals', // 'animals' or 'silos'
//             animal_ids: [],
//             silo_ids: [],
//             item_id: null,
//             quantity: 1,
//             purpose: ''
//         };
//         setConsumptionsList([...consumptionsList, newRow]);
//     };

//     // Remove a row by index
//     const removeRow = (index) => {
//         const newList = [...consumptionsList];
//         newList.splice(index, 1);
//         setConsumptionsList(newList);
//         // Clean up maps for this index
//         const newAnimalsMap = { ...animalsMap };
//         delete newAnimalsMap[index];
//         setAnimalsMap(newAnimalsMap);
//         const newSilosMap = { ...silosMap };
//         delete newSilosMap[index];
//         setSilosMap(newSilosMap);
//         // Clear validation error for that row
//         const newErrors = { ...validationErrors };
//         delete newErrors[index];
//         setValidationErrors(newErrors);
//     };

//     // Update a field in a row
//     const updateRow = (index, field, value) => {
//         const newList = [...consumptionsList];
//         newList[index][field] = value;

//         // Handle category change: reset selections and fetch data
//         if (field === 'category') {
//             newList[index].animal_ids = [];
//             newList[index].silo_ids = [];
//             newList[index].item_id = null;
//             if (value) {
//                 fetchAnimals(value, index);
//                 fetchSilos(value, index);
//             } else {
//                 setAnimalsMap((prev) => {
//                     const newMap = { ...prev };
//                     delete newMap[index];
//                     return newMap;
//                 });
//                 setSilosMap((prev) => {
//                     const newMap = { ...prev };
//                     delete newMap[index];
//                     return newMap;
//                 });
//             }
//         }

//         // Handle consumption type change
//         if (field === 'consumption_type') {
//             if (value === 'animals') {
//                 newList[index].silo_ids = [];
//             } else if (value === 'silos') {
//                 newList[index].animal_ids = [];
//             }
//         }

//         // Handle item selection
//         if (field === 'item_id' && value) {
//             const selectedItem = items.find((i) => i.id === value);
//             if (selectedItem && selectedItem.category !== 'general') {
//                 if (!newList[index].category) {
//                     newList[index].category = selectedItem.category;
//                     fetchAnimals(selectedItem.category, index);
//                     fetchSilos(selectedItem.category, index);
//                 } else if (newList[index].category !== selectedItem.category) {
//                     message.warning(`This item belongs to category "${selectedItem.category}". Category updated.`);
//                     newList[index].category = selectedItem.category;
//                     fetchAnimals(selectedItem.category, index);
//                     fetchSilos(selectedItem.category, index);
//                 }
//             }
//         }

//         // For quantity, validate against current stock
//         if (field === 'quantity') {
//             const itemId = newList[index].item_id;
//             if (itemId) {
//                 const item = items.find((i) => i.id === itemId);
//                 if (item && value > item.current_stock) {
//                     setValidationErrors((prev) => ({
//                         ...prev,
//                         [index]: `Quantity exceeds current stock (${item.current_stock} ${item.unit})`
//                     }));
//                 } else {
//                     setValidationErrors((prev) => {
//                         const newErrors = { ...prev };
//                         delete newErrors[index];
//                         return newErrors;
//                     });
//                 }
//             }
//         }

//         setConsumptionsList(newList);
//     };

//     // Handle "All Animals" checkbox
//     const handleSelectAllAnimals = (index, checked) => {
//         const animals = animalsMap[index] || [];
//         if (checked) {
//             const allIds = animals.map((a) => a.id);
//             updateRow(index, 'animal_ids', allIds);
//         } else {
//             updateRow(index, 'animal_ids', []);
//         }
//     };

//     // Handle "All Silos" checkbox
//     const handleSelectAllSilos = (index, checked) => {
//         const silos = silosMap[index] || [];
//         if (checked && silos.length > 0) {
//             const allIds = silos.map((s) => s.id);
//             updateRow(index, 'silo_ids', allIds);
//         } else {
//             updateRow(index, 'silo_ids', []);
//         }
//     };

//     // Filter items based on selected category
//     const getFilteredItems = (category) => {
//         if (!category) return items;
//         return items.filter((item) => item.category === category || item.category === 'general');
//     };

//     // Validate all rows before submission
//     const validateAllRows = () => {
//         const errors = {};
//         for (let i = 0; i < consumptionsList.length; i++) {
//             const row = consumptionsList[i];
//             if (!row.item_id) {
//                 errors[i] = 'Please select an item';
//             } else if (row.quantity <= 0) {
//                 errors[i] = 'Quantity must be greater than zero';
//             } else if (row.consumption_type === 'animals' && (!row.animal_ids || row.animal_ids.length === 0)) {
//                 errors[i] = 'Please select at least one animal';
//             } else if (row.consumption_type === 'silos' && (!row.silo_ids || row.silo_ids.length === 0)) {
//                 errors[i] = 'Please select at least one silo';
//             } else {
//                 const item = items.find((it) => it.id === row.item_id);
//                 if (item && row.quantity > item.current_stock) {
//                     errors[i] = `Quantity exceeds current stock (${item.current_stock} ${item.unit})`;
//                 }
//             }
//         }
//         setValidationErrors(errors);
//         return Object.keys(errors).length === 0;
//     };

//     // Compute summary of current consumption
//     const consumptionSummary = () => {
//         const summary = {};

//         console.log("consum list", consumptionsList)
//         consumptionsList.forEach((row) => {
//             if (row.item_id && row.quantity > 0) {
//                 const item = items.find((i) => i.id === row.item_id);

//                 console.log("item-cost", item)
//                 if (item) {
//                     if (!summary[row.item_id]) {
//                         summary[row.item_id] = {
//                             name: item.name,
//                             unit: item.unit,
//                             total_qty: 0,
//                             total_cost: 0,
//                             consumption_type: row.consumption_type,
//                             animal_count: row.animal_ids?.length || 0,
//                             silo_count: row.silo_ids?.length || 0
//                         };
//                     }
//                     summary[row.item_id].total_qty += row.quantity;
//                     const unitCost = item.current_avg_cost || 0;
//                     summary[row.item_id].total_cost += row.quantity * unitCost;
//                 }
//             }
//         });
//         return Object.values(summary);
//     };

//     const handleSubmit = async (values) => {
//         if (!validateAllRows()) {
//             message.error('Please fix the errors in the table before submitting');
//             return;
//         }

//         const validConsumptions = consumptionsList.filter((c) => c.item_id && c.quantity > 0);
//         if (validConsumptions.length === 0) {
//             message.error('Please add at least one consumption');
//             return;
//         }

//         const data = {
//             date: values.date.format('YYYY-MM-DD'),
//             userId: account.id,
//             userName: account.firstname,
//             consumptions: validConsumptions.map((c) => ({
//                 category: c.category,
//                 consumption_type: c.consumption_type,
//                 item_id: c.item_id,
//                 quantity: c.quantity,
//                 purpose: c.purpose,
//                 animal_ids: c.animal_ids,
//                 silo_ids: c.silo_ids
//             }))
//         };

//         setLoading(true);
//         try {
//             const response = await api.post('/consumptions/batch', data);
//             if (response.data.success) {
//                 message.success('Consumptions recorded successfully');
//                 history.push('/inventory');
//             } else {
//                 throw new Error(response.data.message);
//             }
//         } catch (error) {
//             console.error(error);
//             message.error(error.response?.data?.error || 'Failed to record consumptions');
//         } finally {
//             setLoading(false);
//         }
//     };

//     // Table columns
//     const columns = [
//         {
//             title: 'Category',
//             dataIndex: 'category',
//             width: 130,
//             render: (category, record, index) => (
//                 <Select
//                     style={{ width: '100%' }}
//                     placeholder="Select category"
//                     value={category}
//                     onChange={(val) => updateRow(index, 'category', val)}
//                     allowClear
//                 >
//                     {categories.map((cat) => (
//                         <Option key={cat} value={cat}>
//                             {cat.charAt(0).toUpperCase() + cat.slice(1)}
//                         </Option>
//                     ))}
//                 </Select>
//             )
//         },
//         {
//             title: 'Consumption Type',
//             dataIndex: 'consumption_type',
//             width: 140,
//             render: (type, record, index) => (
//                 <Select
//                     value={type}
//                     onChange={(val) => updateRow(index, 'consumption_type', val)}
//                     disabled={!record.category}
//                     style={{ width: '100%' }}
//                 >
//                     <Option value="animals">
//                         <TeamOutlined /> To Animals (Individual)
//                     </Option>
//                     <Option value="silos">
//                         <InboxOutlined /> To Silos (Bulk)
//                     </Option>
//                 </Select>
//             )
//         },
//         {
//             title: 'Target',
//             dataIndex: 'target',
//             width: 350,
//             render: (_, record, index) => {
//                 if (!record.category) return <Text type="secondary">Select category first</Text>;

//                 if (record.consumption_type === 'animals') {
//                     const animals = animalsMap[index] || [];
//                     if (loadingAnimals[index]) return <Spin size="small" />;
//                     if (animals.length === 0 && record.category !== 'general') {
//                         return <Text type="secondary">No animals found for this category</Text>;
//                     }
//                     const allSelected = record.animal_ids?.length === animals.length && animals.length > 0;

//                     return (
//                         <Space direction="vertical" style={{ width: '100%' }}>
//                             <Select
//                                 mode="multiple"
//                                 style={{ width: '100%' }}
//                                 placeholder="Select animals (optional - leave empty for all)"
//                                 value={record.animal_ids}
//                                 onChange={(val) => updateRow(index, 'animal_ids', val)}
//                                 optionFilterProp="children"
//                                 disabled={record.category === 'general' || animals.length === 0}
//                                 showSearch
//                                 maxTagCount="responsive"
//                             >
//                                 {animals?.map((animal) => (
//                                     <Option key={animal.id} value={animal.id}>
//                                         <Space>
//                                             <Tag color="blue">{animal.tagNumber || animal.identifier}</Tag>
//                                             <span>{animal.breed || animal.animalName || ''}</span>
//                                             <span style={{ fontSize: 11, color: '#666' }}>
//                                                 {animal.gender === 'male' ? '♂' : animal.gender === 'female' ? '♀' : ''}
//                                             </span>
//                                         </Space>
//                                     </Option>
//                                 ))}
//                             </Select>
//                             {record.category !== 'general' && animals.length > 0 && (
//                                 <Checkbox checked={allSelected} onChange={(e) => handleSelectAllAnimals(index, e.target.checked)}>
//                                     Select All Animals ({animals.length})
//                                 </Checkbox>
//                             )}
//                             <Text type="secondary" style={{ fontSize: 11 }}>
//                                 {animals.length} animals available
//                             </Text>
//                         </Space>
//                     );
//                 } else {
//                     const silos = silosMap[index] || [];
//                     if (loadingSilos[index]) return <Spin size="small" />;
//                     if (silos.length === 0) {
//                         return <Text type="secondary">No silos found for this category</Text>;
//                     }
//                     const allSelected = record.silo_ids?.length === silos.length && silos.length > 0;

//                     return (
//                         <Space direction="vertical" style={{ width: '100%' }}>
//                             <Select
//                                 mode="multiple"
//                                 style={{ width: '100%' }}
//                                 placeholder="Select silos"
//                                 value={record.silo_ids}
//                                 onChange={(val) => updateRow(index, 'silo_ids', val)}
//                                 optionFilterProp="children"
//                                 showSearch
//                                 maxTagCount="responsive"
//                             >
//                                 {silos.map((silo) => (
//                                     <Option key={silo.id} value={silo.id}>
//                                         <Space>
//                                             <Tag color="orange">{silo.silo_number}</Tag>
//                                             <span>{silo.name}</span>
//                                             {silo.capacity && (
//                                                 <span style={{ fontSize: 11, color: '#666' }}>
//                                                     Cap: {silo.capacity} | Occ: {silo.current_occupancy || 0}
//                                                 </span>
//                                             )}
//                                         </Space>
//                                     </Option>
//                                 ))}
//                             </Select>
//                             {silos.length > 0 && (
//                                 <Checkbox checked={allSelected} onChange={(e) => handleSelectAllSilos(index, e.target.checked)}>
//                                     Select All Silos ({silos.length})
//                                 </Checkbox>
//                             )}
//                             <Text type="secondary" style={{ fontSize: 11 }}>
//                                 {silos.length} silos available
//                             </Text>
//                         </Space>
//                     );
//                 }
//             }
//         },
//         {
//             title: 'Item',
//             dataIndex: 'item_id',
//             width: 180,
//             render: (value, record, index) => {
//                 const filtered = getFilteredItems(record.category);
//                 return (
//                     <Select
//                         style={{ width: '100%' }}
//                         placeholder={record.category ? 'Select item' : 'Select category first'}
//                         value={value}
//                         onChange={(val) => updateRow(index, 'item_id', val)}
//                         showSearch
//                         optionFilterProp="children"
//                         disabled={!record.category}
//                     >
//                         {filtered.map((item) => (
//                             <Option key={item.id} value={item.id}>
//                                 {item.name} (Stock: {item.current_stock} {item.unit})
//                             </Option>
//                         ))}
//                     </Select>
//                 );
//             }
//         },
//         {
//             title: 'Quantity',
//             dataIndex: 'quantity',
//             width: 120,
//             render: (value, record, index) => {
//                 const unit = items.find((i) => i.id === record.item_id)?.unit || '';
//                 const error = validationErrors[index];
//                 return (
//                     <div>
//                         <InputNumber
//                             min={0.01}
//                             step={0.01}
//                             value={value}
//                             onChange={(val) => updateRow(index, 'quantity', val)}
//                             style={{ width: '100%' }}
//                             placeholder="Quantity"
//                             status={error ? 'error' : ''}
//                         />
//                         {error && (
//                             <Text type="danger" style={{ fontSize: 12 }}>
//                                 {error}
//                             </Text>
//                         )}
//                     </div>
//                 );
//             }
//         },
//         {
//             title: 'Purpose',
//             dataIndex: 'purpose',
//             width: 150,
//             render: (value, record, index) => (
//                 <Input value={value} onChange={(e) => updateRow(index, 'purpose', e.target.value)} placeholder="e.g., Feeding, Medical" />
//             )
//         },
//         {
//             title: 'Action',
//             width: 80,
//             render: (_, __, index) => (
//                 <Popconfirm title="Remove this item?" onConfirm={() => removeRow(index)}>
//                     <Button icon={<DeleteOutlined />} danger size="small" />
//                 </Popconfirm>
//             )
//         }
//     ];

//     // Summary table data
//     const summaryData = consumptionSummary();

//     const summaryColumns = [
//         { title: 'Item', dataIndex: 'name', key: 'name' },
//         { title: 'Total Quantity', dataIndex: 'total_qty', key: 'total_qty' },
//         { title: 'Unit', dataIndex: 'unit', key: 'unit' },
//         {
//             title: 'Type',
//             key: 'type',
//             render: (_, record) => (
//                 <Tag color={record.consumption_type === 'animals' ? 'blue' : 'orange'}>
//                     {record.consumption_type === 'animals' ? `To ${record.animal_count} Animal(s)` : `To ${record.silo_count} Silo(s)`}
//                 </Tag>
//             )
//         },
//         { title: 'Total Cost (KES)', dataIndex: 'total_cost', key: 'total_cost', render: (val) => val.toFixed(2) }
//     ];

//     return (
//         <>
//             <Card
//                 title="Record Consumption"
//                 extra={
//                     <Link to="/inventory">
//                         <Button icon={<ArrowLeftOutlined />}>Back to Inventory</Button>
//                     </Link>
//                 }
//             >
//                 <Form form={form} onFinish={handleSubmit} layout="vertical">
//                     <Form.Item label="Date" name="date" rules={[{ required: true }]}>
//                         <DatePicker style={{ width: 200 }} format="YYYY-MM-DD" />
//                     </Form.Item>

//                     <Table
//                         dataSource={consumptionsList}
//                         columns={columns}
//                         pagination={false}
//                         footer={() => (
//                             <Button type="dashed" onClick={addRow} icon={<PlusOutlined />}>
//                                 Add Consumption Item
//                             </Button>
//                         )}
//                         locale={{ emptyText: 'No consumption lines. Click "Add Consumption Item" to start.' }}
//                     />

//                     {Object.keys(validationErrors).length > 0 && (
//                         <Alert
//                             message="Validation Errors"
//                             description="Please fix the errors in the table before submitting."
//                             type="error"
//                             showIcon
//                             icon={<WarningOutlined />}
//                             style={{ marginTop: 16 }}
//                         />
//                     )}

//                     {summaryData.length > 0 && (
//                         <>
//                             <Divider />
//                             <Title level={4}>Consumption Summary (Preview)</Title>
//                             <Table dataSource={summaryData} columns={summaryColumns} pagination={false} size="small" rowKey="name" />
//                             <div style={{ marginTop: 12, padding: 12, background: '#f6ffed', borderRadius: 8 }}>
//                                 <Text strong>Total Items: {summaryData.length}</Text>
//                                 <br />
//                                 <Text>
//                                     Total Cost:{' '}
//                                     <strong style={{ color: '#52c41a' }}>
//                                         KES {summaryData.reduce((sum, s) => sum + s.total_cost, 0).toFixed(2)}
//                                     </strong>
//                                 </Text>
//                             </div>
//                         </>
//                     )}

//                     <Form.Item style={{ marginTop: 16 }}>
//                         <Space>
//                             <Button type="primary" htmlType="submit" loading={loading}>
//                                 Record Consumptions
//                             </Button>
//                             <Button onClick={() => history.push('/inventory')}>Cancel</Button>
//                         </Space>
//                     </Form.Item>
//                 </Form>
//             </Card>
//         </>
//     );
// };

// export default ConsumptionPage;

import api from '../api/client';
import React, { useState, useEffect } from 'react';
import {
    Form,
    Input,
    InputNumber,
    DatePicker,
    Button,
    Card,
    message,
    Select,
    Typography,
    Space,
    Table,
    Popconfirm,
    Spin,
    Alert,
    Checkbox,
    Divider,
    Row,
    Col,
    Tag,
    Tooltip
} from 'antd';
import {
    PlusOutlined,
    DeleteOutlined,
    WarningOutlined,
    ArrowLeftOutlined,
    InboxOutlined,
    TeamOutlined,
    DollarOutlined,
    InfoCircleOutlined,
    HistoryOutlined,
    ClockCircleOutlined,
    LineChartOutlined,
    TagsOutlined
} from '@ant-design/icons';
import { useHistory, Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import dayjs from 'dayjs';

const { Title, Text } = Typography;
const { Option } = Select;

const fmtKES = (v) =>
    `KES ${Number(v || 0).toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    })}`;

const ConsumptionPage = () => {
    const history = useHistory();
    const account = useSelector((state) => state.account.user);
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [items, setItems] = useState([]);
    const [consumptionsList, setConsumptionsList] = useState([]);
    const [categories] = useState(['poultry', 'pig', 'goat', 'sheep', 'weaner', 'general']);
    const [animalsMap, setAnimalsMap] = useState({});
    const [silosMap, setSilosMap] = useState({});
    const [loadingAnimals, setLoadingAnimals] = useState({});
    const [loadingSilos, setLoadingSilos] = useState({});
    const [validationErrors, setValidationErrors] = useState({});

    const [costHistoryMap, setCostHistoryMap] = useState({});
    const [loadingCostHistory, setLoadingCostHistory] = useState({});

    const fetchItems = async () => {
        try {
            const res = await api.get('/items-cost');
            setItems(res.data);
        } catch (error) {
            console.error('Error fetching items:', error);
            message.error('Failed to load items');
        }
    };

    const fetchAnimals = async (category, rowIndex) => {
        if (!category) return;
        setLoadingAnimals((prev) => ({ ...prev, [rowIndex]: true }));
        try {
            const res = await api.get('/animals', {
                params: { type: category, status: 'alive' }
            });
            setAnimalsMap((prev) => ({ ...prev, [rowIndex]: res.data }));
        } catch (error) {
            console.error('Animals fetch error:', error.response?.data?.error || error.message);
        } finally {
            setLoadingAnimals((prev) => ({ ...prev, [rowIndex]: false }));
        }
    };

    const fetchSilos = async (category, rowIndex) => {
        if (!category) return;
        setLoadingSilos((prev) => ({ ...prev, [rowIndex]: true }));
        try {
            const res = await api.get(`/silos/by-type/${category}`);
            setSilosMap((prev) => ({ ...prev, [rowIndex]: res.data || [] }));
        } catch (error) {
            console.error('Silos fetch error:', error);
            setSilosMap((prev) => ({ ...prev, [rowIndex]: [] }));
        } finally {
            setLoadingSilos((prev) => ({ ...prev, [rowIndex]: false }));
        }
    };

    const fetchCostHistory = async (itemId, rowIndex) => {
        if (!itemId) return;
        setLoadingCostHistory((prev) => ({ ...prev, [rowIndex]: true }));
        try {
            const res = await api.get(`/items/${itemId}/cost-history`);
            setCostHistoryMap((prev) => ({ ...prev, [rowIndex]: res.data }));
        } catch (error) {
            console.error('Cost history fetch error:', error);
            setCostHistoryMap((prev) => ({ ...prev, [rowIndex]: null }));
        } finally {
            setLoadingCostHistory((prev) => ({ ...prev, [rowIndex]: false }));
        }
    };

    useEffect(() => {
        fetchItems();
    }, []);

    const addRow = () => {
        const newRow = {
            key: Date.now(),
            category: null,
            consumption_type: 'animals',
            animal_ids: [],
            silo_ids: [],
            item_id: null,
            quantity: 1,
            purpose: '',
            unit_cost: null,
            cost_source: 'average',
            cost_option_id: null,
            cost_option_label: null
        };
        setConsumptionsList([...consumptionsList, newRow]);
    };

    const removeRow = (index) => {
        const newList = [...consumptionsList];
        newList.splice(index, 1);
        setConsumptionsList(newList);
        const clean = (map) => {
            const m = { ...map };
            delete m[index];
            return m;
        };
        setAnimalsMap(clean);
        setSilosMap(clean);
        setCostHistoryMap(clean);
        setValidationErrors(clean);
    };

    const updateRow = (index, field, value) => {
        const newList = [...consumptionsList];
        newList[index][field] = value;

        if (field === 'category') {
            newList[index].animal_ids = [];
            newList[index].silo_ids = [];
            newList[index].item_id = null;
            if (value) {
                fetchAnimals(value, index);
                fetchSilos(value, index);
            }
        }

        if (field === 'consumption_type') {
            if (value === 'animals') newList[index].silo_ids = [];
            else if (value === 'silos') newList[index].animal_ids = [];
        }

        if (field === 'item_id' && value) {
            const selectedItem = items.find((i) => i.id === value);
            if (selectedItem && selectedItem.category !== 'general') {
                if (!newList[index].category) {
                    newList[index].category = selectedItem.category;
                    fetchAnimals(selectedItem.category, index);
                    fetchSilos(selectedItem.category, index);
                } else if (newList[index].category !== selectedItem.category) {
                    message.warning(`This item belongs to category "${selectedItem.category}". Category updated.`);
                    newList[index].category = selectedItem.category;
                    fetchAnimals(selectedItem.category, index);
                    fetchSilos(selectedItem.category, index);
                }
            }

            // Reset cost fields — the cost history will set them
            newList[index].unit_cost = null;
            newList[index].cost_source = null;
            newList[index].cost_option_id = null;
            newList[index].cost_option_label = null;

            fetchCostHistory(value, index);
        }

        if (field === 'quantity') {
            const itemId = newList[index].item_id;
            if (itemId) {
                const item = items.find((i) => i.id === itemId);
                if (item && value > item.current_stock) {
                    setValidationErrors((prev) => ({
                        ...prev,
                        [index]: `Quantity exceeds current stock (${item.current_stock} ${item.unit})`
                    }));
                } else {
                    setValidationErrors((prev) => {
                        const e = { ...prev };
                        delete e[index];
                        return e;
                    });
                }
            }
        }

        setConsumptionsList(newList);
    };

    // When cost history finishes loading, auto-apply the latest cost
    useEffect(() => {
        setConsumptionsList((prev) => {
            const copy = [...prev];
            Object.keys(costHistoryMap).forEach((key) => {
                const idx = Number(key);
                const data = costHistoryMap[idx];
                if (!data || !copy[idx]) return;
                if (copy[idx].unit_cost !== null && copy[idx].unit_cost !== undefined) return;

                // Default = latest purchase cost (falls back to average if no batches)
                if (data.latestCost && data.latestCost > 0 && data.latestBatch) {
                    copy[idx].unit_cost = Number(data.latestCost);
                    copy[idx].cost_source = 'latest';
                    copy[idx].cost_option_id = data.latestBatch.inventory_item_id;
                    copy[idx].cost_option_label = `Latest (KES ${Number(data.latestCost).toFixed(2)})`;
                } else {
                    copy[idx].unit_cost = Number(data.averageCost || 0);
                    copy[idx].cost_source = 'average';
                    copy[idx].cost_option_id = null;
                    copy[idx].cost_option_label = `Average (KES ${Number(data.averageCost || 0).toFixed(2)})`;
                }
            });
            return copy;
        });
        // eslint-disable-next-line
    }, [costHistoryMap]);

    const handleCostChange = (index, optionValue) => {
        const data = costHistoryMap[index];
        if (!data) return;

        const newList = [...consumptionsList];

        if (optionValue === 'average') {
            newList[index].unit_cost = Number(data.averageCost || 0);
            newList[index].cost_source = 'average';
            newList[index].cost_option_id = null;
            newList[index].cost_option_label = `Average (KES ${Number(data.averageCost || 0).toFixed(2)})`;
        } else if (optionValue === 'latest') {
            newList[index].unit_cost = Number(data.latestCost || 0);
            newList[index].cost_source = 'latest';
            newList[index].cost_option_id = data.latestBatch?.inventory_item_id || null;
            newList[index].cost_option_label = `Latest (KES ${Number(data.latestCost || 0).toFixed(2)})`;
        } else {
            const batchId = Number(optionValue);
            const batch = (data.batches || []).find((b) => b.inventory_item_id === batchId);
            if (batch) {
                newList[index].unit_cost = Number(batch.unit_cost);
                newList[index].cost_source = 'batch';
                newList[index].cost_option_id = batch.inventory_item_id;
                newList[index].cost_option_label = `${fmtKES(batch.unit_cost)} · ${batch.remaining_quantity} left · ${dayjs(
                    batch.purchase_date
                ).format('DD MMM YY')}${batch.reference ? ' · ' + batch.reference : ''}`;
            }
        }

        setConsumptionsList(newList);
    };

    const handleSelectAllAnimals = (index, checked) => {
        const animals = animalsMap[index] || [];
        updateRow(index, 'animal_ids', checked ? animals.map((a) => a.id) : []);
    };

    const handleSelectAllSilos = (index, checked) => {
        const silos = silosMap[index] || [];
        updateRow(index, 'silo_ids', checked ? silos.map((s) => s.id) : []);
    };

    const getFilteredItems = (category) => {
        if (!category) return items;
        return items.filter((item) => item.category === category || item.category === 'general');
    };

    const validateAllRows = () => {
        const errors = {};
        for (let i = 0; i < consumptionsList.length; i++) {
            const row = consumptionsList[i];
            if (!row.item_id) errors[i] = 'Please select an item';
            else if (row.quantity <= 0) errors[i] = 'Quantity must be greater than zero';
            else if (row.unit_cost === null || row.unit_cost === undefined) errors[i] = 'Please select a unit cost';
            else if (row.consumption_type === 'animals' && (!row.animal_ids || row.animal_ids.length === 0))
                errors[i] = 'Please select at least one animal';
            else if (row.consumption_type === 'silos' && (!row.silo_ids || row.silo_ids.length === 0))
                errors[i] = 'Please select at least one silo';
            else {
                const item = items.find((it) => it.id === row.item_id);
                if (item && row.quantity > item.current_stock)
                    errors[i] = `Quantity exceeds current stock (${item.current_stock} ${item.unit})`;
            }
        }
        setValidationErrors(errors);
        return Object.keys(errors).length === 0;
    };

    const consumptionSummary = () => {
        const summary = {};
        consumptionsList.forEach((row) => {
            if (row.item_id && row.quantity > 0) {
                const item = items.find((i) => i.id === row.item_id);
                if (item) {
                    if (!summary[row.item_id]) {
                        summary[row.item_id] = {
                            name: item.name,
                            unit: item.unit,
                            total_qty: 0,
                            total_cost: 0,
                            consumption_type: row.consumption_type,
                            animal_count: row.animal_ids?.length || 0,
                            silo_count: row.silo_ids?.length || 0,
                            cost_sources: new Set()
                        };
                    }
                    summary[row.item_id].total_qty += row.quantity;
                    const unitCost = Number(row.unit_cost || 0);
                    summary[row.item_id].total_cost += row.quantity * unitCost;
                    summary[row.item_id].cost_sources.add(row.cost_source || 'average');
                }
            }
        });
        return Object.values(summary).map((s) => ({
            ...s,
            cost_sources: Array.from(s.cost_sources).join(', ')
        }));
    };

    const handleSubmit = async (values) => {
        if (!validateAllRows()) {
            message.error('Please fix the errors in the table before submitting');
            return;
        }

        const validConsumptions = consumptionsList.filter((c) => c.item_id && c.quantity > 0);
        if (validConsumptions.length === 0) {
            message.error('Please add at least one consumption');
            return;
        }

        const data = {
            date: values.date.format('YYYY-MM-DD'),
            userId: account.id,
            userName: account.firstname,
            consumptions: validConsumptions.map((c) => ({
                category: c.category,
                consumption_type: c.consumption_type,
                item_id: c.item_id,
                quantity: c.quantity,
                purpose: c.purpose,
                animal_ids: c.animal_ids,
                silo_ids: c.silo_ids,
                unit_cost: c.unit_cost,
                cost_source: c.cost_source,
                cost_option_id: c.cost_option_id,
                cost_option_label: c.cost_option_label
            }))
        };

        setLoading(true);
        try {
            const response = await api.post('/consumptions/batch', data);
            if (response.data.success) {
                message.success('Consumptions recorded successfully');
                history.push('/inventory');
            } else {
                throw new Error(response.data.message);
            }
        } catch (error) {
            console.error(error);
            message.error(error.response?.data?.error || 'Failed to record consumptions');
        } finally {
            setLoading(false);
        }
    };

    // ---- Cost option builder ----
    const buildCostOptions = (index, record) => {
        const data = costHistoryMap[index];
        const item = items.find((i) => i.id === record?.item_id);
        const options = [];

        const itemAvg = Number(item?.current_avg_cost || 0);
        const avgCost = data?.averageCost != null ? Number(data.averageCost) : itemAvg;

        // Always show Average
        options.push({
            value: 'average',
            label: 'Average Cost',
            meta: fmtKES(avgCost),
            icon: <LineChartOutlined style={{ color: '#1677ff' }} />,
            badge: 'AVG',
            badgeColor: 'blue',
            subMeta: data?.batches?.length > 0 ? `Weighted across ${data.batches.length} batch(es)` : 'No purchase history yet'
        });

        // Latest purchase
        if (data?.latestCost > 0 && data?.latestBatch) {
            options.push({
                value: 'latest',
                label: 'Latest Purchase',
                meta: fmtKES(data.latestCost),
                icon: <ClockCircleOutlined style={{ color: '#52c41a' }} />,
                badge: 'CURRENT',
                badgeColor: 'green',
                subMeta:
                    (data.latestBatch.purchase_date ? dayjs(data.latestBatch.purchase_date).format('DD MMM YYYY') : '') +
                    (data.latestBatch.reference ? ' · ' + data.latestBatch.reference : '')
            });
        }

        // Every batch
        (data?.batches || []).forEach((b) => {
            const depleted = Number(b.remaining_quantity) <= 0;
            options.push({
                value: String(b.inventory_item_id),
                label: `Batch ${b.reference || 'PO-' + b.inventory_item_id}`,
                meta: fmtKES(b.unit_cost),
                subMeta: `${b.quantity_received} ${item?.unit || ''} bought · ${depleted ? '0' : b.remaining_quantity} ${
                    item?.unit || ''
                } left · ${b.purchase_date ? dayjs(b.purchase_date).format('DD MMM YYYY') : '—'}`,
                icon: <TagsOutlined style={{ color: depleted ? '#bbb' : '#722ed1' }} />,
                badge: depleted ? 'DEPLETED' : 'IN STOCK',
                badgeColor: depleted ? 'default' : 'purple'
            });
        });

        return options;
    };

    const columns = [
        {
            title: 'Category',
            dataIndex: 'category',
            width: 120,
            render: (category, record, index) => (
                <Select
                    style={{ width: '100%' }}
                    placeholder="Category"
                    value={category}
                    onChange={(val) => updateRow(index, 'category', val)}
                    allowClear
                >
                    {categories.map((cat) => (
                        <Option key={cat} value={cat}>
                            {cat.charAt(0).toUpperCase() + cat.slice(1)}
                        </Option>
                    ))}
                </Select>
            )
        },
        {
            title: 'Type',
            dataIndex: 'consumption_type',
            width: 120,
            render: (type, record, index) => (
                <Select
                    value={type}
                    onChange={(val) => updateRow(index, 'consumption_type', val)}
                    disabled={!record.category}
                    style={{ width: '100%' }}
                >
                    <Option value="animals">Animals</Option>
                    <Option value="silos">Silos</Option>
                </Select>
            )
        },
        {
            title: 'Target',
            dataIndex: 'target',
            width: 300,
            render: (_, record, index) => {
                if (!record.category) return <Text type="secondary">Select category first</Text>;

                if (record.consumption_type === 'animals') {
                    const animals = animalsMap[index] || [];
                    if (loadingAnimals[index]) return <Spin size="small" />;
                    if (animals.length === 0 && record.category !== 'general') return <Text type="secondary">No animals found</Text>;
                    const allSelected = record.animal_ids?.length === animals.length && animals.length > 0;

                    return (
                        <Space direction="vertical" style={{ width: '100%' }}>
                            <Select
                                mode="multiple"
                                style={{ width: '100%' }}
                                placeholder="Select animals"
                                value={record.animal_ids}
                                onChange={(val) => updateRow(index, 'animal_ids', val)}
                                optionFilterProp="children"
                                disabled={record.category === 'general' || animals.length === 0}
                                showSearch
                                maxTagCount="responsive"
                            >
                                {animals.map((animal) => (
                                    <Option key={animal.id} value={animal.id}>
                                        <Space>
                                            <Tag color="blue">{animal.tagNumber || animal.identifier}</Tag>
                                            <span>{animal.breed || animal.animalName || ''}</span>
                                        </Space>
                                    </Option>
                                ))}
                            </Select>
                            {record.category !== 'general' && animals.length > 0 && (
                                <Checkbox checked={allSelected} onChange={(e) => handleSelectAllAnimals(index, e.target.checked)}>
                                    Select All ({animals.length})
                                </Checkbox>
                            )}
                        </Space>
                    );
                } else {
                    const silos = silosMap[index] || [];
                    if (loadingSilos[index]) return <Spin size="small" />;
                    if (silos.length === 0) return <Text type="secondary">No silos found</Text>;
                    const allSelected = record.silo_ids?.length === silos.length && silos.length > 0;

                    return (
                        <Space direction="vertical" style={{ width: '100%' }}>
                            <Select
                                mode="multiple"
                                style={{ width: '100%' }}
                                placeholder="Select silos"
                                value={record.silo_ids}
                                onChange={(val) => updateRow(index, 'silo_ids', val)}
                                optionFilterProp="children"
                                showSearch
                                maxTagCount="responsive"
                            >
                                {silos.map((silo) => (
                                    <Option key={silo.id} value={silo.id}>
                                        <Space>
                                            <Tag color="orange">{silo.silo_number}</Tag>
                                            <span>{silo.name}</span>
                                        </Space>
                                    </Option>
                                ))}
                            </Select>
                            {silos.length > 0 && (
                                <Checkbox checked={allSelected} onChange={(e) => handleSelectAllSilos(index, e.target.checked)}>
                                    Select All ({silos.length})
                                </Checkbox>
                            )}
                        </Space>
                    );
                }
            }
        },
        {
            title: 'Item',
            dataIndex: 'item_id',
            width: 180,
            render: (value, record, index) => {
                const filtered = getFilteredItems(record.category);
                return (
                    <Select
                        style={{ width: '100%' }}
                        placeholder={record.category ? 'Select item' : 'Select category'}
                        value={value}
                        onChange={(val) => updateRow(index, 'item_id', val)}
                        showSearch
                        optionFilterProp="children"
                        disabled={!record.category}
                    >
                        {filtered.map((item) => (
                            <Option key={item.id} value={item.id}>
                                {item.name} (Stock: {item.current_stock} {item.unit})
                            </Option>
                        ))}
                    </Select>
                );
            }
        },
        {
            title: (
                <Space>
                    <DollarOutlined />
                    <span>Unit Cost</span>
                </Space>
            ),
            dataIndex: 'unit_cost',
            width: 340,
            render: (value, record, index) => {
                if (!record.item_id) return <Text type="secondary">Select item first</Text>;
                if (loadingCostHistory[index]) return <Spin size="small" />;

                const options = buildCostOptions(index);
                const selectedValue = (() => {
                    if (record.cost_source === 'batch' && record.cost_option_id) return String(record.cost_option_id);
                    if (record.cost_source === 'latest') return 'latest';
                    return 'average';
                })();

                return (
                    <Space direction="vertical" size={4} style={{ width: '100%' }}>
                        <Select
                            style={{ width: '100%' }}
                            value={selectedValue}
                            onChange={(v) => handleCostChange(index, v)}
                            dropdownStyle={{ minWidth: 420 }}
                            popupMatchSelectWidth={false}
                        >
                            {options.map((opt) => (
                                <Option key={opt.value} value={opt.value} label={opt.label}>
                                    <div
                                        style={{
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            alignItems: 'center',
                                            gap: 12,
                                            padding: '2px 0'
                                        }}
                                    >
                                        <Space>
                                            {opt.icon}
                                            <div style={{ display: 'flex', flexDirection: 'column' }}>
                                                {/* <span style={{ fontSize: 13 }}>{opt.label}</span> */}
                                                {opt.subMeta && <span style={{ fontSize: 11, color: '#888' }}>{opt.subMeta}</span>}
                                            </div>
                                        </Space>
                                        <Space>
                                            <Text strong>{opt.meta}</Text>
                                            <Tag color={opt.badgeColor} style={{ fontSize: 10, margin: 0 }}>
                                                {opt.badge}
                                            </Tag>
                                        </Space>
                                    </div>
                                </Option>
                            ))}
                        </Select>

                        {value !== null && value !== undefined ? (
                            <Text type="secondary" style={{ fontSize: 11 }}>
                                Applied: <b>{fmtKES(value)}</b>
                                {record.cost_option_label && (
                                    <span style={{ marginLeft: 6, color: '#999' }}>· {record.cost_option_label}</span>
                                )}
                            </Text>
                        ) : null}
                    </Space>
                );
            }
        },
        {
            title: 'Quantity',
            dataIndex: 'quantity',
            width: 160,
            render: (value, record, index) => {
                const unit = items.find((i) => i.id === record.item_id)?.unit || '';
                const error = validationErrors[index];
                return (
                    <div>
                        <InputNumber
                            min={0.01}
                            step={0.01}
                            value={value}
                            onChange={(val) => updateRow(index, 'quantity', val)}
                            style={{ width: '100%' }}
                            placeholder="Qty"
                            status={error ? 'error' : ''}
                            addonAfter={unit}
                        />
                        {error && (
                            <Text type="danger" style={{ fontSize: 12 }}>
                                {error}
                            </Text>
                        )}
                    </div>
                );
            }
        },
        {
            title: 'Line Cost',
            key: 'line_cost',
            width: 130,
            align: 'right',
            render: (_, record) => {
                const q = Number(record.quantity) || 0;
                const c = Number(record.unit_cost) || 0;
                return <Text strong>{fmtKES(q * c)}</Text>;
            }
        },
        {
            title: 'Purpose',
            dataIndex: 'purpose',
            width: 140,
            render: (value, record, index) => (
                <Input value={value} onChange={(e) => updateRow(index, 'purpose', e.target.value)} placeholder="Feeding..." />
            )
        },
        {
            title: '',
            width: 50,
            render: (_, __, index) => (
                <Popconfirm title="Remove this item?" onConfirm={() => removeRow(index)}>
                    <Button icon={<DeleteOutlined />} danger size="small" />
                </Popconfirm>
            )
        }
    ];

    const summaryData = consumptionSummary();

    const summaryColumns = [
        { title: 'Item', dataIndex: 'name' },
        {
            title: 'Cost Source',
            dataIndex: 'cost_sources',
            render: (v) => <Tag color={v.includes('batch') ? 'purple' : v === 'latest' ? 'green' : 'blue'}>{v}</Tag>
        },
        { title: 'Quantity', dataIndex: 'total_qty' },
        { title: 'Unit', dataIndex: 'unit' },
        {
            title: 'Type',
            render: (_, record) => (
                <Tag color={record.consumption_type === 'animals' ? 'blue' : 'orange'}>
                    {record.consumption_type === 'animals' ? `→ ${record.animal_count} animal(s)` : `→ ${record.silo_count} silo(s)`}
                </Tag>
            )
        },
        {
            title: 'Total Cost',
            dataIndex: 'total_cost',
            align: 'right',
            render: (v) => <Text strong>{fmtKES(v)}</Text>
        }
    ];

    return (
        <Card
            title="Record Consumption"
            extra={
                <Link to="/inventory">
                    <Button icon={<ArrowLeftOutlined />}>Back to Inventory</Button>
                </Link>
            }
        >
            <Form form={form} onFinish={handleSubmit} layout="vertical">
                <Form.Item label="Date" name="date" rules={[{ required: true }]}>
                    <DatePicker style={{ width: 200 }} format="YYYY-MM-DD" defaultValue={dayjs()} />
                </Form.Item>

                <Table
                    dataSource={consumptionsList}
                    columns={columns}
                    pagination={false}
                    scroll={{ x: 1500 }}
                    footer={() => (
                        <Button type="dashed" onClick={addRow} icon={<PlusOutlined />}>
                            Add Consumption Item
                        </Button>
                    )}
                    locale={{
                        emptyText: 'No consumption lines. Click "Add Consumption Item" to start.'
                    }}
                />

                {Object.keys(validationErrors).length > 0 && (
                    <Alert
                        message="Validation Errors"
                        description="Please fix the errors in the table before submitting."
                        type="error"
                        showIcon
                        icon={<WarningOutlined />}
                        style={{ marginTop: 16 }}
                    />
                )}

                {summaryData.length > 0 && (
                    <>
                        <Divider />
                        <Title level={4}>Consumption Summary (Preview)</Title>
                        <Table dataSource={summaryData} columns={summaryColumns} pagination={false} size="small" rowKey="name" />
                        <div
                            style={{
                                marginTop: 12,
                                padding: 12,
                                background: '#f6ffed',
                                borderRadius: 8
                            }}
                        >
                            <Text strong>Total Items: {summaryData.length}</Text>
                            <br />
                            <Text>
                                Total Cost:{' '}
                                <strong style={{ color: '#52c41a' }}>
                                    {fmtKES(summaryData.reduce((sum, s) => sum + s.total_cost, 0))}
                                </strong>
                            </Text>
                        </div>
                    </>
                )}

                <Form.Item style={{ marginTop: 16 }}>
                    <Space>
                        <Button type="primary" htmlType="submit" loading={loading}>
                            Record Consumptions
                        </Button>
                        <Button onClick={() => history.push('/inventory')}>Cancel</Button>
                    </Space>
                </Form.Item>
            </Form>
        </Card>
    );
};

export default ConsumptionPage;
